// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.wallet.shared

import org.multipaz.cbor.DataItem
import org.multipaz.wallet.shared.WalletBackendVerificationLinkExpiredException
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap

fun WalletBackendVerificationLinkExpiredException.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "Ch4nNnd_gKYr6y33K2SYeEgcDKEBlLgytRNr77rlQBc")
val WalletBackendVerificationLinkExpiredException_cborSchemaId = ByteString(10, 30, 39, 54, 119, 127, -128, -90, 43, -21, 45, -9, 43, 100, -104, 120, 72, 28, 12, -95, 1, -108, -72, 50, -75, 19, 107, -17, -70, -27, 64, 23)

fun WalletBackendVerificationLinkExpiredException.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "WalletBackendVerificationLinkExpiredException")
    return builder.end().build()
}

fun WalletBackendVerificationLinkExpiredException_fromDataItem(dataItem: DataItem): WalletBackendVerificationLinkExpiredException {
    return WalletBackendVerificationLinkExpiredException(
    )
}
